import { ChevronSvg } from './chevron';

export const NextChunkArrowHtml = () => `
    <span>Swipe for next chapter</span>
    <div class="next-chunk-arrow">${ChevronSvg}</div>
`;
